// src/config/mapbox.js
// Mapbox configuration

export const MAPBOX_CONFIG = {
  // Public access token for client-side Mapbox GL
  // Prefer environment variable locally to avoid token issues
  ACCESS_TOKEN: process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWFicW0wMTRiMm1zNGdjNWhkbWdvIn0.xeXlfJFw_oQw6oqRXvPsAg',
  
  // Secret token for server-side tile requests (for caching)
  // Do not use secret tokens on the client in production
  SECRET_TOKEN: process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw',
  
  // Available map styles
  STYLES: {
    STREETS: 'mapbox://styles/mapbox/streets-v12',
    SATELLITE: 'mapbox://styles/mapbox/satellite-v9',
    SATELLITE_STREETS: 'mapbox://styles/mapbox/satellite-streets-v12',
    LIGHT: 'mapbox://styles/mapbox/light-v11',
    DARK: 'mapbox://styles/mapbox/dark-v11',
    OUTDOORS: 'mapbox://styles/mapbox/outdoors-v12',
    NAVIGATION_DAY: 'mapbox://styles/mapbox/navigation-day-v1',
    NAVIGATION_NIGHT: 'mapbox://styles/mapbox/navigation-night-v1'
  },
  
  // Default configuration
  DEFAULT_STYLE: 'mapbox://styles/mapbox/satellite-streets-v12',
  DEFAULT_ZOOM: 14,
  DEFAULT_CENTER: [36.8228, -1.2876], // Nairobi CBD center [lng, lat]
  
  // Tile server URLs for OpenLayers integration (using secret token for server-side requests)
  TILE_URLS: {
    STREETS: `https://api.mapbox.com/styles/v1/mapbox/streets-v12/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw'}`,
    SATELLITE: `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw'}`,
    SATELLITE_STREETS: `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw'}`,
    LIGHT: `https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw'}`,
    DARK: `https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw'}`,
    OUTDOORS: `https://api.mapbox.com/styles/v1/mapbox/outdoors-v12/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_SECRET_TOKEN || 'sk.eyJ1Ijoid2F5bmVmYWdpdG9uZSIsImEiOiJjbWJqYWhmbW8wY2k3MmtyMWgwcmgwcXVyIn0.FzF6ZksYCciFa2BcJtlkqw'}`
  },
  
  // Attribution text
  ATTRIBUTION: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>'
};

export default MAPBOX_CONFIG;